/* global Glide */

(function() {
  /**
   * On document ready
   */
  document.addEventListener('DOMContentLoaded', function() {
    /**
     * Scrollbar width CSS variable
     */
    window.addEventListener('load resize', scrollbarWidth)
    scrollbarWidth()

    /**
     * Mobile navigation event listeners
     */
    document.querySelectorAll('.l-nav__toggle').forEach(item => {
      item.addEventListener('click', menu.toggle)
    })
    document.addEventListener('keydown', function(evt) {
      const isEsc = 'key' in evt ? (evt.key === 'Escape' || evt.key === 'Esc') : evt.keyCode === 27
      if (isEsc && menu.isOpen) menu.close()
    })

    /**
     * Carousel
     */
    glideInit('.s-carousel', {
      type: 'carousel',
      gap: 0,
      autoplay: 4000,
      hoverpause: true,
      touchRatio: 1
    })

    /**
     * Slider
     */
    glideInit('.s-slider__el', {
      type: 'carousel',
      perView: 2,
      gap: 15,
      touchRatio: 1,
      peek: 200,
      breakpoints: {
        768: {
          gap: 8,
          perView: 1,
          peek: 50
        }
      }
    })

    /**
     * Packages
     *
     * Add event listeners for flip buttons - so users without hover
     * functionality can access content.
     */
    const flipBtns = document.querySelectorAll('.s-packages__flip')
    if (flipBtns) {
      flipBtns.forEach(function(btnEl) {
        btnEl.addEventListener('click', function(e) {
          const item = e.target.parentElement

          if (item.hasAttribute('data-visible')) {
            // closing
            item.removeAttribute('data-visible')
            item.setAttribute('aria-expanded', 'false')
          } else {
            // opening
            item.setAttribute('data-visible', '')
            item.setAttribute('aria-expanded', 'true')
          }
        })
      })
    }

    /**
     * Fallback for object-fit: cover if not supported
     * Mainly for IE11 and EdgeHTML
     */
    if ('objectFit' in document.documentElement.style === false) {
      const containers = document.querySelectorAll('.img-cover-parent')
      containers.forEach(function(container) {
        const image = container.querySelector('.img-cover')
        if (image) {
          const url = image.getAttribute('src')
          if (url) {
            container.style.backgroundImage = `url(${url})`
            container.classList.add('img-cover-parent--none')
          }
        }
      })
    }
  })

  /**
   * Functions and state for Mobile Navigation
   */
  const menu = {
    isOpen: false,
    open: function() {
      menu.isOpen = true
      document.querySelector('body').classList.add('ns')
      document.querySelector('.l-nav').setAttribute('data-state', 'open')
      document.querySelector('.l-nav__toggle').setAttribute('aria-expanded', 'true')
    },
    close: function() {
      menu.isOpen = false
      document.querySelector('body').classList.remove('ns')
      document.querySelector('.l-nav').setAttribute('data-state', 'closed')
      document.querySelector('.l-nav__toggle').setAttribute('aria-expanded', 'false')
    },
    toggle: function() {
      if (!menu.isOpen) {
        menu.open()
      } else {
        menu.close()
      }
    }
  }

  /**
   * glideInit
   *
   * initialise glide js on any items with selector using provided options
   *
   * @param { string } selector
   * @param { object } options
   */
  function glideInit(selector, options) {
    const items = document.querySelectorAll(selector)
    if (items) {
      items.forEach(function(item) {
        const numSlides = item.getAttribute('data-slides')
        const liveRegion = item.querySelector('.glide__live')
        const bullets = item.querySelectorAll('.glide__bullet')

        const carousel = new Glide(item, options).mount()

        carousel.on('run', function() {
          const current = carousel.index + 1
          liveRegion.textContent = 'Item ' + current + ' of ' + numSlides

          if (bullets) {
            bullets.forEach(function(bullet) {
              const currentText = bullet.querySelector('[data-current]')
              currentText.style.display = 'none'

              if (parseInt(bullet.getAttribute('data-slide')) === carousel.index) {
                currentText.style.display = null
              }
            })
          }
        })
      })
    }
  }

  /**
   * scrollbarWidth
   *
   * Gets the width of the scrollbar by comparing the window and body widths.
   * Adds to a CSS property on document root to be used within CSS
   */
  function scrollbarWidth() {
    const prevWidth = window.getComputedStyle(document.documentElement).getPropertyValue('--scrollbar-width')
    const newWidth = `${window.innerWidth - document.body.clientWidth}px`

    if (newWidth !== prevWidth) {
      document.documentElement.style.setProperty('--scrollbar-width', newWidth)
    }
  }
})()
